(function(){
  "use strict";
  var reduce=matchMedia("(prefers-reduced-motion:reduce)").matches,root=document.documentElement;
  document.getElementById("themeBtn").addEventListener("click",function(){
    var cur=root.getAttribute("data-theme");
    if(!cur)cur=matchMedia("(prefers-color-scheme:dark)").matches?"dark":"light";
    root.setAttribute("data-theme",cur==="dark"?"light":"dark");});
  var nav=document.getElementById("nav");
  addEventListener("scroll",function(){nav.classList.toggle("scrolled",scrollY>8);},{passive:true});

  var views={home:document.getElementById("view-home"),product:document.getElementById("view-product")};
  function go(name){for(var k in views)views[k].classList.toggle("active",k===name);
    document.querySelectorAll(".nav-links button").forEach(function(b){b.classList.toggle("active",b.getAttribute("data-go")===name);});
    scrollTo({top:0,behavior:reduce?"auto":"smooth"});revealScan();updateMobileBar(name);}
  document.addEventListener("click",function(e){
    var g=e.target.closest("[data-go]"),s=e.target.closest("[data-scroll]");
    if(g){e.preventDefault();var d=g.getAttribute("data-go");if(d)go(d);
      var sc=g.getAttribute("data-scroll");if(sc)setTimeout(function(){var el=document.getElementById(sc);if(el)el.scrollIntoView({behavior:reduce?"auto":"smooth"});},60);return;}
    if(s&&!g){var el=document.getElementById(s.getAttribute("data-scroll"));if(el){e.preventDefault();el.scrollIntoView({behavior:reduce?"auto":"smooth"});}}});

  var MAP={},META={
    corgi:{k:"Breed №01 · The show-off",t:"The Corgi Lamp",tag:"All ears, no legs, maximum charm — glowing on your shelf.",note:"Corgi people: you already have 200 photos. Here's the one that glows."},
    dachshund:{k:"Breed №02 · The long one",t:"The Dachshund Lamp",tag:"Small dog. Enormous presence. Now cast in solid resin, glowing warm.",note:"For the long dog with the even longer list of nicknames."},
    frenchie:{k:"Breed №03 · The character",t:"The Frenchie Lamp",tag:"Bat ears, zero chill, maximum charm — lit up in colored glass.",note:"Bat ears, snorts, zero chill — captured in glowing glass."},
    cat:{k:"Breed №04 · The boss",t:"The Cat Lamp",tag:"The one who owns the house, immortalized in glowing glass.",note:"For the one who owns you — not the other way around."},
    midnight:{k:"Breed №05 · The mystery",t:"The Midnight Cat Lamp",tag:"A black-glass cat with a warm secret — it glows from within.",note:"A black cat that vanishes when the lights go out — until now."}
  };
  document.querySelectorAll("#breedGrid .breed").forEach(function(c){MAP[c.getAttribute("data-breed")]=c.querySelector("img").src;});

  document.querySelectorAll("#breedGrid .breed").forEach(function(card){
    var ph=card.querySelector(".photo");
    card.addEventListener("mouseenter",function(){ph.classList.add("off");});
    card.addEventListener("mouseleave",function(){ph.classList.remove("off");});
    card.addEventListener("click",function(){selectBreed(card.getAttribute("data-breed"));});
  });

  var current="dachshund";
  function selectBreed(key){
    current=key;var m=META[key];
    document.getElementById("pdpImg").src=MAP[key];
    document.getElementById("pdpKicker").textContent=m.k;
    document.getElementById("pdpTitle").textContent=m.t;
    document.getElementById("pdpTag").textContent=m.tag;
    document.getElementById("pdpNote").textContent=m.note;
    document.querySelectorAll("#pdpSwatches .swatch").forEach(function(s){s.classList.toggle("active",s.getAttribute("data-breed")===key);});
    document.querySelectorAll("#pdpThumbs .pdp-thumb").forEach(function(t){t.classList.toggle("active",t.getAttribute("data-breed")===key);});
    var row1=document.querySelector('#petExtra .slotsw[data-slot="1"]');
    if(row1){slotSel[1]=key;row1.querySelectorAll(".swatch").forEach(function(x){x.classList.toggle("active",x.getAttribute("data-breed")===key);});}
    go("product");
  }
  document.querySelectorAll("#pdpSwatches .swatch,#pdpThumbs .pdp-thumb").forEach(function(b){
    b.addEventListener("click",function(){selectBreed(b.getAttribute("data-breed"));});});

  /* pricing: pack size + per-pet choices + shipping protection */
  var PRICE={single:{now:49,was:69,qty:1},pair:{now:83,was:98,qty:2},trio:{now:117,was:147,qty:3},zoo:{now:176,was:245,qty:5}};
  var PETS=[{k:"corgi",n:"Corgi"},{k:"dachshund",n:"Dachshund"},{k:"frenchie",n:"Frenchie"},{k:"cat",n:"Cat"},{k:"midnight",n:"Midnight"}];
  var SIMG={};document.querySelectorAll("#pdpSwatches .swatch").forEach(function(s){SIMG[s.getAttribute("data-breed")]=s.querySelector("img").src;});
  var slotSel={};
  var pack="pair",ins=false;
  function insCost(){return 7.99+3*(PRICE[pack].qty-1);}
  function pkgTotal(){return PRICE[pack].now+(ins?insCost():0);}
  function fmt(n){return "$"+(Number.isInteger(n)?n:n.toFixed(2));}
  function renderPets(){
    var q=PRICE[pack].qty,wrap=document.getElementById("petExtra");
    var bp=document.getElementById("breedPick");if(bp)bp.style.display=(q>=2)?"none":"";
    if(q<2){wrap.innerHTML="";return;}
    var defs=["dachshund","corgi","frenchie","cat","midnight"],html='<div class="slots-head">Pick your pets</div><div class="petslots">';
    for(var i=1;i<=q;i++){
      var sel=(i===1)?current:defs[i-1]; slotSel[i]=sel;
      html+='<div class="petslot"><div class="slot-label">Pet '+i+'</div><div class="swatches slotsw" data-slot="'+i+'">';
      html+=PETS.map(function(p){return '<button class="swatch'+(p.k===sel?' active':'')+'" data-breed="'+p.k+'"><img src="'+SIMG[p.k]+'" alt=""><span>'+p.n+'</span></button>';}).join("");
      html+='</div></div>';
    }
    wrap.innerHTML=html+'</div>';
    wrap.querySelectorAll(".slotsw").forEach(function(row){
      var slot=+row.getAttribute("data-slot");
      row.querySelectorAll(".swatch").forEach(function(btn){btn.addEventListener("click",function(){
        var b=btn.getAttribute("data-breed"); slotSel[slot]=b;
        row.querySelectorAll(".swatch").forEach(function(x){x.classList.toggle("active",x===btn);});
        if(slot===1)selectBreed(b);
      });});
    });
  }
  function updatePrice(){
    var p=PRICE[pack];
    document.getElementById("pNow").textContent=fmt(p.now);
    document.getElementById("pWas").textContent=fmt(p.was);
    document.getElementById("pSave").textContent="Save $"+(p.was-p.now);
    var ip=document.getElementById("insPrice");if(ip)ip.textContent="+$"+insCost().toFixed(2);
    document.getElementById("btnTotal").textContent=fmt(pkgTotal());
    if(views.product.classList.contains("active"))updateMobileBar("product");
  }
  document.querySelectorAll("#packs .pack").forEach(function(b){b.addEventListener("click",function(){
    pack=b.getAttribute("data-pack");
    document.querySelectorAll("#packs .pack").forEach(function(x){x.classList.toggle("active",x===b);});
    renderPets();updatePrice();});});
  var ichk=document.getElementById("insChk");
  if(ichk)ichk.addEventListener("change",function(e){ins=e.target.checked;updatePrice();});
  renderPets();updatePrice();

  /* hero lights */
  var heroOff=false,heroPhoto=document.getElementById("heroPhoto"),heroStage=document.getElementById("heroStage");
  function setHero(off){heroOff=off;heroPhoto.classList.toggle("off",off);heroStage.classList.toggle("lit",off);
    document.getElementById("toggleLabel").textContent=off?"Lights off":"Lights on";
    document.getElementById("stageToggle").setAttribute("aria-pressed",String(off));
    document.getElementById("heroLights").textContent=off?"Turn it back on":"See it glow ↓";}
  document.getElementById("stageToggle").addEventListener("click",function(){setHero(!heroOff);});
  document.getElementById("heroLights").addEventListener("click",function(){setHero(!heroOff);});

  /* pdp lights */
  var pdpOff=false,pdpPhoto=document.getElementById("pdpPhoto");
  document.getElementById("pdpToggle").addEventListener("click",function(){
    pdpOff=!pdpOff;pdpPhoto.classList.toggle("off",pdpOff);
    document.getElementById("pdpToggleLabel").textContent=pdpOff?"Lights on":"Lights off";
    document.getElementById("pdpToggle").setAttribute("aria-pressed",String(pdpOff));});

  /* reveal */
  var io=null;
  function revealScan(){var els=document.querySelectorAll(".reveal:not(.in),[data-reveal]:not(.in)");
    if(reduce||!("IntersectionObserver" in window)){els.forEach(function(e){e.classList.add("in");});return;}
    if(!io)io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add("in");io.unobserve(x.target);}});},{threshold:.16,rootMargin:"0px 0px -14% 0px"});
    els.forEach(function(e){io.observe(e);});}
  revealScan();

  var mbar=document.getElementById("mobilebar"),mbPrice=document.getElementById("mbPrice"),mbSub=document.getElementById("mbSub"),mbBtn=document.getElementById("mbBtn");
  function updateMobileBar(name){
    if(name==="product"){var m=META[current];mbPrice.textContent=fmt(pkgTotal());mbSub.textContent=m?m.t:"Pick your breed";mbBtn.textContent="Add to cart";mbBtn.removeAttribute("data-go");mbBtn.setAttribute("href","/products/the-glow-zoo-lamp");}
    else{mbPrice.textContent="From $49";mbSub.textContent="5 breeds glowing";mbBtn.textContent="Find your breed";mbBtn.setAttribute("data-go","product");mbBtn.setAttribute("href","#");}}
  updateMobileBar("home");

  var prog=document.getElementById("progress"),px=document.querySelectorAll("[data-parallax]"),ticking=false;
  function onScroll(){
    var st=scrollY,vh=innerHeight,h=document.documentElement.scrollHeight-vh;
    prog.style.width=(h>0?Math.min(100,st/h*100):0)+"%";
    mbar.classList.toggle("show",st>200);
    if(!reduce)px.forEach(function(el){var r=el.getBoundingClientRect();var sp=parseFloat(el.getAttribute("data-parallax"))||0;
      el.style.transform="translate3d(0,"+(((r.top+r.height/2)-vh/2)*-sp).toFixed(1)+"px,0)";});
    ticking=false;}
  addEventListener("scroll",function(){if(!ticking){requestAnimationFrame(onScroll);ticking=true;}},{passive:true});
  addEventListener("resize",onScroll,{passive:true});onScroll();

  if(matchMedia("(hover:none)").matches && ("IntersectionObserver" in window) && !reduce){
    var tio=new IntersectionObserver(function(en){en.forEach(function(x){
      if(x.isIntersecting){var ph=x.target.querySelector(".photo");if(ph){ph.classList.add("off");setTimeout(function(){ph.classList.remove("off");},1500);}}});},{threshold:.6});
    document.querySelectorAll("#breedGrid .breed").forEach(function(c){tio.observe(c);});
  }

  if(!reduce)setTimeout(function(){setHero(true);setTimeout(function(){setHero(false);},2600);},1100);

  window.__gz={selectBreed:selectBreed,simg:SIMG};
})();



(function(){
  "use strict";
  var ENDPOINT=""; /* <-- paste your Klaviyo / Shopify / Formspree POST url here to actually collect leads */
  var joined=false; try{joined=localStorage.getItem("gz_joined")==="1";}catch(e){}
  function validEmail(v){return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);}
  function save(payload,cb){
    try{localStorage.setItem("gz_joined","1");localStorage.setItem("gz_lead",JSON.stringify(payload));}catch(e){}
    joined=true;
    if(ENDPOINT){try{fetch(ENDPOINT,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)});}catch(e){}}
    if(cb)cb();
  }
  var modal=document.getElementById("waitModal"),mbreed="";
  var lastFocus=null;
  function openModal(){lastFocus=document.activeElement;modal.classList.add("open");var e=document.getElementById("memail");if(e&&!modal.classList.contains("done"))setTimeout(function(){e.focus();},60);}
  function closeModal(){modal.classList.remove("open");if(lastFocus&&lastFocus.focus){try{lastFocus.focus();}catch(x){}}}
  document.addEventListener("keydown",function(e){
    if(e.key!=="Tab"||!modal.classList.contains("open"))return;
    var f=Array.prototype.slice.call(modal.querySelectorAll('button,[href],input,select,[tabindex]:not([tabindex="-1"])')).filter(function(el){return el.offsetParent!==null&&!el.disabled;});
    if(!f.length)return;var first=f[0],last=f[f.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
  });
  function markJoined(){var j=document.getElementById("join");if(j&&joined)j.classList.add("done");}
  var popped=false; try{popped=sessionStorage.getItem("gz_pop")==="1";}catch(e){}
  function markPop(){try{sessionStorage.setItem("gz_pop","1");}catch(e){}popped=true;}
  document.addEventListener("click",function(ev){var t=ev.target.closest("[data-join]");if(t){ev.preventDefault();openModal();}});
  document.getElementById("mclose").addEventListener("click",function(){closeModal();markPop();});
  document.getElementById("mokclose").addEventListener("click",closeModal);
  document.getElementById("mdismiss").addEventListener("click",function(){closeModal();markPop();});
  modal.addEventListener("click",function(ev){if(ev.target===modal){closeModal();markPop();}});
  document.addEventListener("keydown",function(ev){if(ev.key==="Escape")closeModal();});
  document.querySelectorAll("#mchips .mchip").forEach(function(c){c.addEventListener("click",function(){
    var was=c.classList.contains("active");
    document.querySelectorAll("#mchips .mchip").forEach(function(x){x.classList.remove("active");});
    if(!was){c.classList.add("active");mbreed=c.getAttribute("data-breed");}else{mbreed="";}
  });});
  document.getElementById("msubmit").addEventListener("click",function(){
    var em=document.getElementById("memail").value.trim(),err=document.getElementById("merr");
    if(!validEmail(em)){err.style.display="block";return;}
    err.style.display="none";
    save({email:em,phone:document.getElementById("mphone").value.trim(),breed:mbreed,sms:document.getElementById("mconsent").checked,ts:Date.now(),src:"modal"},
      function(){var nm={corgi:"Corgi",dachshund:"Dachshund",frenchie:"Frenchie",cat:"cat",midnight:"Midnight Cat"};
        document.getElementById("okbreed").textContent=nm[mbreed]||"pet";modal.classList.add("done");markJoined();});
  });
  var jform=document.getElementById("jform");
  if(jform)jform.addEventListener("submit",function(ev){ev.preventDefault();
    var em=document.getElementById("jemail").value.trim();
    if(!validEmail(em)){document.getElementById("jemail").focus();return;}
    save({email:em,ts:Date.now(),src:"section"},function(){document.getElementById("join").classList.add("done");markJoined();});
  });
  /* pop-up: fire once per session on scroll-depth OR exit-intent (20s fallback) — opens the quiz */
  function firePop(){if(joined||popped||modal.classList.contains("open"))return;
    var vp=document.getElementById("view-product");
    if(vp&&vp.classList.contains("active")){setTimeout(firePop,20000);return;}
    if(window.__gzQuiz){window.__gzQuiz();}else{openModal();}markPop();}
  if(!joined && !popped){
    var pf={};
    pf.clean=function(){clearTimeout(pf.t);removeEventListener("scroll",pf.s);document.removeEventListener("mouseout",pf.e);};
    pf.s=function(){var d=document.documentElement.scrollHeight-innerHeight;if(d>0&&scrollY/d>0.45){pf.clean();firePop();}};
    pf.e=function(ev){if(ev.clientY<=0){pf.clean();firePop();}};
    pf.t=setTimeout(function(){pf.clean();firePop();},20000);
    addEventListener("scroll",pf.s,{passive:true});
    document.addEventListener("mouseout",pf.e);
  }
  markJoined();
  window.__gzJoin=function(b){if(b){document.querySelectorAll("#mchips .mchip").forEach(function(x){var on=x.getAttribute("data-breed")===b;x.classList.toggle("active",on);if(on)mbreed=b;});}openModal();};
  window.__gzSaveLead=function(payload,cb){save(payload,cb);};
})();



(function(){
  "use strict";
  var Q=[
    {q:"It's 8pm. Your pet is…",a:[["Doing zoomies for no reason","corgi"],["Burrowed under a blanket","dachshund"],["Snoring on your lap","frenchie"],["On the highest shelf, judging you","cat"],["Out prowling in the dark","midnight"]]},
    {q:"Best word for them?",a:[["Sunshine","corgi"],["Stubborn","dachshund"],["Goofball","frenchie"],["Regal","cat"],["Mysterious","midnight"]]},
    {q:"Where does the lamp go?",a:[["Living-room centerpiece","corgi"],["On my desk","dachshund"],["Right by the couch","frenchie"],["My nightstand","cat"],["Bedroom shelf, lights low","midnight"]]}
  ];
  var NAME={corgi:"Corgi",dachshund:"Dachshund",frenchie:"Frenchie",cat:"Cat",midnight:"Midnight Cat"};
  var modal=document.getElementById("quizModal"),body=document.getElementById("qzBody"),dots=document.getElementById("qzDots").children;
  var step=0,score={},best="corgi",lead=false;
  function valid(v){return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);}
  function open(){step=0;score={};best="corgi";lead=false;modal.classList.add("open");render();}
  function close(){modal.classList.remove("open");}
  function setDots(i){for(var k=0;k<dots.length;k++)dots[k].className=k<=i?"on":"";}
  function computeBest(){var bv=-1,order=["corgi","dachshund","frenchie","cat","midnight"];order.forEach(function(k){var v=score[k]||0;if(v>bv){bv=v;best=k;}});}
  function render(){
    setDots(step);
    var item=Q[step],h='<div class="qz-q">'+item.q+'</div><div class="qz-opts">';
    item.a.forEach(function(o){h+='<button class="qz-opt" data-b="'+o[1]+'">'+o[0]+'</button>';});
    body.innerHTML=h+'</div>';
    body.querySelectorAll(".qz-opt").forEach(function(btn){btn.addEventListener("click",function(){
      var b=btn.getAttribute("data-b");score[b]=(score[b]||0)+1;step++;
      if(step<Q.length)render();else{computeBest();gate();}
    });});
  }
  function gate(){
    setDots(dots.length-1);
    body.innerHTML='<div class="qz-q">Your match is ready 🐾</div>'
      +'<p style="text-align:center;color:var(--text-soft);font-family:var(--font-ui);font-size:14px;margin:-6px 0 16px">Where should we send it? You\'ll get first dibs when the drop opens — no spam.</p>'
      +'<div class="mfield"><input type="email" id="qzEmail" placeholder="you@email.com"></div>'
      +'<div class="merr" id="qzErr">Please enter a valid email.</div>'
      +'<button class="btn" id="qzReveal" style="width:100%;justify-content:center;padding:15px">Reveal my match →</button>'
      +'<button class="mdismiss" id="qzSkip">Skip — just show me</button>';
    var em=document.getElementById("qzEmail");if(em)setTimeout(function(){em.focus();},60);
    document.getElementById("qzReveal").addEventListener("click",function(){
      var v=document.getElementById("qzEmail").value.trim();
      if(!valid(v)){document.getElementById("qzErr").style.display="block";return;}
      lead=true;if(window.__gzSaveLead)window.__gzSaveLead({email:v,breed:best,src:"quiz",ts:Date.now()});result();
    });
    document.getElementById("qzSkip").addEventListener("click",result);
  }
  function result(){
    setDots(dots.length-1);
    var simg=(window.__gz&&window.__gz.simg)||{},img=simg[best]||"";
    var h='<div class="qz-result">'+(img?'<img class="qz-pic" src="'+img+'" alt="">':'')
      +'<h3>You\'re a '+NAME[best]+' person.</h3>'
      +'<p>'+(lead?"You're on the early list — check your inbox. ":"")+'Here\'s your glow pet.</p>'
      +'<div class="qz-actions"><button class="btn" id="qzSee">See the '+NAME[best]+' lamp →</button>';
    if(!lead)h+='<button class="btn ghost" id="qzJoin2">Reserve mine — join the list</button>';
    body.innerHTML=h+'</div></div>';
    document.getElementById("qzSee").addEventListener("click",function(){close();if(window.__gz)window.__gz.selectBreed(best);});
    var jb=document.getElementById("qzJoin2");if(jb)jb.addEventListener("click",function(){close();if(window.__gzJoin)window.__gzJoin(best);});
  }
  document.addEventListener("click",function(e){if(e.target.closest("[data-quiz]")){e.preventDefault();open();}});
  document.getElementById("qzClose").addEventListener("click",close);
  modal.addEventListener("click",function(e){if(e.target===modal)close();});
  window.__gzQuiz=open;
})();